import { CommonHeader } from "../../../components/commons";

const ApproveExpenses = () => {
  return (
    <>
      <CommonHeader title="Approve Expenses" />
    </>
  );
};

export default ApproveExpenses;
